import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Home, Search, MessageCircle, ArrowRight, MapPin } from "lucide-react";

const links = [
  { icon: Home, label: "Accueil", path: "/", desc: "Retourner à la page d'accueil" },
  { icon: Search, label: "Nos logements", path: "/voyageurs", desc: "Découvrir nos biens disponibles" },
  { icon: MapPin, label: "Nous contacter", path: "/contact", desc: "Notre équipe est à votre disposition" },
  { icon: MessageCircle, label: "Blog", path: "/blog", desc: "Guides et actualités locales" },
];

export default function NotFoundPage() {
  return (
    <div className="min-h-[80vh] bg-[#F5F0EB] flex items-center" data-testid="page-404">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20 w-full">
        <div className="text-center mb-14">
          {/* Big 404 */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, type: "spring" }}
            className="relative inline-block mb-6"
          >
            <span className="font-mono text-[120px] sm:text-[160px] font-black text-[#004333]/[0.06] leading-none select-none">
              404
            </span>
            <span className="absolute inset-0 flex items-center justify-center font-mono text-5xl sm:text-6xl font-black text-[#004333]">
              404
            </span>
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.15 }}
            className="font-display text-2xl sm:text-3xl text-[#004333] mb-3"
          >
            Cette page n'existe pas
          </motion.h1>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.25 }}
            className="text-[#6B5E50] max-w-md mx-auto"
          >
            La page que vous cherchez a peut-être été déplacée ou n'existe plus.
            Voici quelques liens utiles pour vous aider.
          </motion.p>
        </div>

        {/* Links grid */}
        <div className="grid sm:grid-cols-2 gap-4 max-w-2xl mx-auto">
          {links.map((link, i) => (
            <motion.div
              key={link.path}
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 + i * 0.08 }}
            >
              <Link
                to={link.path}
                className="group flex items-start gap-4 p-5 bg-white rounded-2xl border border-[#E0D6CA] shadow-sm hover:shadow-md hover:border-[#C9922A]/30 transition-all"
                data-testid={`404-link-${i}`}
              >
                <div className="w-10 h-10 rounded-xl bg-[#C9922A]/10 flex items-center justify-center flex-shrink-0 group-hover:bg-[#C9922A]/15 transition-colors">
                  <link.icon className="w-5 h-5 text-[#C9922A]" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="font-semibold text-[#004333] group-hover:text-[#C9922A] transition-colors">
                      {link.label}
                    </span>
                    <ArrowRight className="w-3.5 h-3.5 text-[#C9922A] opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition-all" />
                  </div>
                  <span className="text-sm text-[#6B5E50]">{link.desc}</span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
